(function() {
  function killSticky() {
    // كل العناصر اللي فيها sticky في الـ header
    var selectors = [
      'header', 
      '.header', 
      '.shopify-section-header-group',
      '[id*="shopify-section-header"]',
      '.header-wrapper',
      '.section-header',
      '[class*="sticky"]',
      '[data-sticky]'
    ];

    selectors.forEach(function(sel) {
      document.querySelectorAll(sel).forEach(function(el) {
        var computed = window.getComputedStyle(el).position;
        if (computed === 'sticky' || computed === 'fixed') {
          el.style.setProperty('position', 'static', 'important');
          el.style.setProperty('top', 'auto', 'important');
        }
        // كمان نشيل أي class فيها sticky
        el.classList.forEach(function(cls) {
          if (cls.toLowerCase().includes('sticky')) {
            el.classList.remove(cls);
          }
        });
      });
    });
  }

  // شغله فورًا
  killSticky();

  // وكمان بعد ما الصفحة تخلص تحميل بالكامل
  window.addEventListener('load', killSticky);

  // وراقب أي تغيير في الـ DOM (لو فيه كود تاني بيرجع يحط sticky تاني)
  var observer = new MutationObserver(function() {
    killSticky();
  });

  observer.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'style']
  });
})();
